import { render, staticRenderFns } from "./FinancesAccountBonuses.vue?vue&type=template&id=243db4d3&"
import script from "./FinancesAccountBonuses.vue?vue&type=script&lang=js&"
export * from "./FinancesAccountBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports